<template>
  <transition name="el-fade-in" mode="out-in">
    <HolaconLottie v-if="createLoading == 'created'" key="create-subevent-loading" />
    <el-row :gutter="10" v-else key="create-subevent-content">
      <div class="attendee-subevent-section" v-if="subEvents.length > 0">
        <div class="subevent-item" v-for="event in subEvents" :key="event.id">
          <div class="container" v-if="getSubEvent(event.subEventID)">
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.subEvent") }}</span>
            <span>
              <strong>{{ getSubEvent(event.subEventID).title }}</strong>
            </span>
            <!-- <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.source") }}</span>
            <span v-html="$t('participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.package')"></span> -->
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.registrationDate") }}</span>
            <span>
              <b>{{ $moment(event.createDate).format(dateFormatEvent($store.state.event.event.dateFormat) + " " + timeFormatEvent($store.state.event.event.timeFormat)) }}</b>
            </span>
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.confirmationStatus") }}</span>
            <el-dropdown placement="bottom-start" @command="handleCommand">
              <span class="status" :class="[{ pending: event.status == 0 }, { confirmed: event.status == 1 }, { rejected: event.status == 2 }]">
                <i class="fas fa-clock" v-if="event.status == 0"></i>
                <i class="fas fa-check-circle" v-if="event.status == 1"></i>
                <i class="fas fa-times-circle" v-if="event.status == 2"></i>
                {{ getEnumsDisplay("SubEventRegistrationStatus", event.status) }}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="status-pending-approve" v-if="event.status != 1" :command="{ subevent: event, status: 1 }"> <i class="fas fa-check"></i> {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.confirm") }} </el-dropdown-item>
                <el-dropdown-item class="status-pending-reject" v-if="event.status != 2" :command="{ subevent: event, status: 2 }"> <i class="fas fa-times"></i> {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.reject") }} </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="attendee-subevent-edit">
              <el-tooltip class="item" effect="dark" :content="$t('participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.seeDetails')" placement="top-start">
                <el-button size="small" icon="fas fa-search" :loading="createLoading == 'sub-event-question-loading-' + event.subEventID" circle @click="openQuestion(event)"></el-button>
              </el-tooltip>
              <!-- <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
                <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
                  <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
                </el-popconfirm>
              </el-tooltip> -->
            </div>
          </div>
          <transition name="el-fade-in" mode="out-in">
            <div class="subevent-registration-section" key="subevent-question-list-key" v-if="event.showQuestion">
              <div class="subevent-registration-item" v-for="question in event.questions" :key="'sub-event-quest-' + question.id">
                <span>{{ getQuestionOne(question, event.subEventID).title }}</span>
                <QuestionItem :question="getQuestionOne(question, event.subEventID)" />
              </div>
            </div>
          </transition>
        </div>
      </div>
      <el-alert v-else type="info" :show-icon="true" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.noSubEventRegistration')" style="border-radius:8px" :closable="false"></el-alert>
    </el-row>
  </transition>
</template>

<script>
import QuestionItem from "../../register-form/Inputs/QuestionItem.vue";
export default {
  components: {
    QuestionItem
  },
  props: ["data"],
  data() {
    return {
      subEvents: [],
      createLoading: false,
      timeout: null,
      showSubEventDetails: false
    };
  },
  methods: {
    async openQuestion(item) {
      this.createLoading = "sub-event-question-loading-" + item.subEventID;
      if (this.timeout != null) clearTimeout(this.timeout);
      if (item.showQuestion) {
        item.showQuestion = !item.showQuestion;
        this.createLoading = false;
      } else {
        this.timeout = setTimeout(async () => {
          var responsoQuestions = await this.$store.dispatch("getQuestionsObject", { id: item.subEventID, type: 5 });
          item.questionList = responsoQuestions.data.data.items;
          item.showQuestion = !item.showQuestion;
          this.createLoading = false;
        }, 500);
      }
    },
    getQuestionOne(question, subID) {
      var allQuestions = this.subEvents.find(x => x.subEventID == subID).questionList;
      var returned = allQuestions.find(x => x.id == question.registrationInputID);
      if (returned == null) {
        return returned;
      }

      returned.answer = question.answer;
      returned.answers = question.answers;
      return returned;
    },
    async handleCommand(command) {
      if (command.status == 1) {
        var confirm = await this.$store.dispatch("participantConfirmSubEvent", command.subevent.id);
        if (!confirm.data.alert.hasError) {
          this.$emit("refresh");
        }
      }
      if (command.status == 2) {
        var cancel = await this.$store.dispatch("participantCancelSubEvent", command.subevent.id);
        if (!cancel.data.alert.hasError) {
          this.$emit("refresh");
        }
      }
    },
    getSubEvent(id) {
      return this.$store.state.subevents.items.find(x => x.id == id);
    }
  },
  computed: {
    subEventList() {
      return this.$store.state.subevents.items;
    }
  },
  async created() {
    if (this.timeout != null) clearTimeout(this.timeout);
    this.createLoading = "created";
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getSubEvents");
      this.createLoading = false;
    }, 500);

    if (this.data != null && this.data != undefined) {
      this.subEvents = this.data.map(x => {
        return {
          ...x,
          showQuestion: false,
          questionList: []
        };
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AttendeeSubEventRegistration.vue